export const chooseRangeStep = 1;
export const dimensionsStep = 2
export const materialStep = 3
export const energyTypeStep = 4
export const optionsStep = 5 // steps 5-9 
export const summaryStep = 10
export const estimateStep = 20
export const informingTypeStep = 21
export const userDataStep = 22
export const confirmationStep = 30